import rightArrow from './rightArrow.svg';
export const rightArrowIcon = rightArrow;